import { HttpErrorResponse } from '@angular/common/http';
import { EStateStatus } from '@app/app.state';
import { IApiError } from '@app/core/interfaces/error.interface';
import { IPvsTaskInfo } from '@app/core/interfaces/pvs-task.interface';
import { createReducer, on } from '@ngrx/store';
import { PvsTaskActions } from './pvs-task.actions';

export interface IPvsTaskState {
  task: IPvsTaskInfo;
  status: EStateStatus;
  error: HttpErrorResponse & { error: IApiError };
}
export const initialState: IPvsTaskState = {
  task: null,
  status: EStateStatus.PENDING,
  error: null,
};

export const PvsTaskReducer = createReducer(
  initialState,
  on(
    PvsTaskActions.requestTaskInfo,
    PvsTaskActions.requestSetTaskAccept,
    PvsTaskActions.requestSetTaskOnWay,
    PvsTaskActions.requestSetTaskAtObject,
    PvsTaskActions.requestSetTaskInProgress,
    PvsTaskActions.requestSetTaskComplete,
    PvsTaskActions.requestSetTaskCancel,
    (state) => ({
      ...state,
      status: EStateStatus.LOADING,
    }),
  ),
  on(PvsTaskActions.requestTaskInfoSuccess, (state, payload) => ({
    ...state,
    task: payload.task,
    status: EStateStatus.SUCCESS,
  })),
  on(
    PvsTaskActions.requestSetTaskAcceptSuccess,
    PvsTaskActions.requestSetTaskOnWaySuccess,
    PvsTaskActions.requestSetTaskAtObjectSuccess,
    PvsTaskActions.requestSetTaskInProgressSuccess,
    PvsTaskActions.requestSetTaskCompleteSuccess,
    PvsTaskActions.requestSetTaskCancelSuccess,
    (state) => ({
      ...state,
      status: EStateStatus.SUCCESS,
    }),
  ),
  on(
    PvsTaskActions.requestTaskInfoError,
    PvsTaskActions.requestSetTaskAcceptError,
    PvsTaskActions.requestSetTaskOnWayError,
    PvsTaskActions.requestSetTaskAtObjectError,
    PvsTaskActions.requestSetTaskInProgressError,
    PvsTaskActions.requestSetTaskCompleteError,
    PvsTaskActions.requestSetTaskCancelError,
    (state, payload) => ({
      ...state,
      error: payload.error,
      status: EStateStatus.ERROR,
    }),
  ),
);
